import { render, staticRenderFns } from "./RemainingAllowanceExceededError.vue?vue&type=template&id=5cfda231"
import script from "./RemainingAllowanceExceededError.vue?vue&type=script&lang=js"
export * from "./RemainingAllowanceExceededError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports